import { createSlice } from "@reduxjs/toolkit";
import toolbarConfiguration from "../components/Toolbar/toolbarConfig";

const {
  category,
  sku,
  DC,
  supplier,
  risk_type,
  tier2_suppliers,
  tier2_skus,
  supplier_org,
  assembly_item,
} = toolbarConfiguration.filterMap;

const detailSlice = createSlice({
  name: "detail",
  initialState: {
    isProcessing: false,
    tableData: [],
    prevTableData: [],
    filteredTableData: [],
    headerData: [],
    prevHeaderData: [],
    selectedLegend: "",
    fromParent: true,
    filters: {
      [category.filterId]: [],
      [sku.filterId]: [],
      [supplier.filterId]: [],
      [DC.filterId]: [],
      [tier2_suppliers.filterId]: [],
      [tier2_skus.filterId]: [],
      [risk_type.filterId]: [],
      [supplier_org.filterId]: [],
      [assembly_item.filterId]: [],
      country: [],
    },
    resetTriggered: false,
  },
  reducers: {
    setProcessing(state, action) {
      state.isProcessing = action.payload;
    },
    setTableData(state, action) {
      state.tableData = action.payload;
    },
    setFilteredTableData(state, action) {
      state.filteredTableData = action.payload;
    },
    setFilters(state, action) {
      const { filters, filterId } = action.payload;
      const currentFilters = state.filters;

      if (filterId && filterId !== "status") {
        delete filters[filterId];
      }

      state.filters = {
        ...currentFilters,
        ...filters,
      };
    },
    setPrevTableData(state, action) {
      state.prevTableData = action.payload;
    },
    setDetailHeaderData(state, action) {
      state.headerData = action.payload;
    },
    setDetailPrevHeaderData(state, action) {
      state.prevHeaderData = action.payload;
    },
    setSelectedLegend(state, action) {
      state.selectedLegend = action.payload;
    },
    setFromParent(state, action) {
      state.fromParent = action.payload;
    },
    setResetTriggered(state, action) {
      state.resetTriggered = action.payload;
    },
  },
});

export const {
  setProcessing,
  setTableData,
  setFilteredTableData,
  setPrevTableData,
  setDetailHeaderData,
  setSelectedLegend,
  setFromParent,
  setFilters,
  setResetTriggered,
} = detailSlice.actions;

export default detailSlice.reducer;
